// extracted by mini-css-extract-plugin
export default {"imageWrapper":"XQ-z","hovered":"YQ-z","hoverImage":"ZQ-z","mainImage":"_Q-z","imageNoBackground":"aR-z","fullSizeImage":"bR-z"};